import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

const state = {
  sectors: null,
  separateProducts: null,
  products: null,
  noSectorList: null,
  cartProducts: [],
  orderDetails: null,
  couponDetails: null,
  couponApplied: null,
  maxProductsPerCpf: null,
  productsDetails: null,
  lastOrderAndCart: null,
  errorProducts: null,
  selectedSector: null,
  listSeats: null,
  selectedSeat: null,
  showSeatMap: false,
  alertSectors: false,
  hoverShape: null,
  couponCard: null,
  maxProductsPerCoupon: null,
  showPreSale: false,
  cartAbandoned: false,
  timeToViewProducts: null,
  screenTimeOn: 0,
  chosenSector: null,
  facebookCookies: {
    fbc: "",
    fbp: "",
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
